/*
====================================================================
    Add Policy Checkbox to Checkout Page
====================================================================
*/

/*
 * @returns {boolean} - Returns true if the cart widget exists on the page.
 */
function cartWidgetExists() {
  const mainExists = document.querySelector(".mini_cart_footer") !== null;
  return mainExists;
}

/**
 * Inserts a new div with specified text before the div that contains the button with ID 'checkout-pay-button'.
 * @param {string} textContent - The text or HTML content to be added in the new div.
 * @returns {void}
 */
function addElemBeforeSubtotal(textContent) {
  // Get the button element by ID
  const subtotalDisplay = document.querySelector(
    ".total.row.fl_between.al_center"
  );

  // Check if the button element exists
  if (subtotalDisplay) {
    // Get the parent div of the checkout button
    const targetDiv = document.querySelector("div.mini_cart_footer");

    // Create the new div element
    const newDiv = document.createElement("div");
    newDiv.innerHTML = textContent;

    // Insert the new content at the start of the target div
    targetDiv.insertBefore(newDiv, targetDiv.firstChild);
  } else {
    console.error('".total.row.fl_between.al_center" not found.');
  }
}

function updateCheckoutBtnState(isEnabled = null) {
  if (isEnabled === null) {
    isEnabled = isPolicyCheckboxChecked();
  }
  document.querySelector(".mini_cart_footer button.btn-checkout").disabled =
    !isEnabled;
}

function isPolicyCheckboxChecked() {
  const checkbox = document.getElementById("mbtek-policy-checkbox");
  const res = checkbox && checkbox.checked;

  updateCheckoutBtnState(res);

  return res;
}

/*
 * Toggles the checkbox with ID 'mbtek-policy-checkbox'.
 * @returns {void}
 */
// eslint-disable-next-line no-unused-vars
function toggleWidgetPolicyCheckbox() {
  console.log("Toggling policy checkbox...");
  const checkbox = document.getElementById("mbtek-policy-checkbox");
  if (checkbox) {
    checkbox.checked = !checkbox.checked;
  } else {
    console.error('Checkbox with ID "mbtek-policy-checkbox" not found.');
  }
  updateCheckoutBtnState();
}

// When HTML loads completely
document.addEventListener("DOMContentLoaded", function () {
  console.log("Loading Widget Policy Checkbox...");

  if (!cartWidgetExists()) {
    console.error("Cart Widget not found.");
  }

  // Add a new div before the checkout button
  addElemBeforeSubtotal(`
      <div>
          <input 
              type="checkbox" id="mbtek-policy-checkbox" name="mbtek-policy-checkbox" required style="
              display: inline-block;height: 1rem;width: 1rem;pointer-events: all !important;
              border: 1px solid #ff6700;padding: 0.6rem;cursor: pointer;"
              value="0"
              onclick="toggleWidgetPolicyCheckbox()"
              >
              <label for="mbtek-policy-checkbox" style="cursor: pointer;pointer-events: all !important;"
                  onclick="toggleWidgetPolicyCheckbox()"
              >
              By checking this box, you agree to our shipping, return and refund product policy. 
              To read the policies, 
              <a href="https://www.mbtek.com/pages/shipping-refund-policy" target="_blank">
                  click here
              </a>
          </label>
      </div>
      `);

  // After inserting, prevent submission if the checkbox is not policy checked

  const checkoutButton = document.querySelector(
    ".mini_cart_footer button.btn-checkout"
  );

  let preventCheckoutHandler = function (event) {
    if (!isPolicyCheckboxChecked()) {
      event.preventDefault();
      alert(
        "Please agree to our shipping, return and refund product policy before continuing to checkout."
      );
    } else {
      console.log("Policy Checkbox is checked. Redirecting to checkout...");
    }
  };

  if (checkoutButton) {
    updateCheckoutBtnState(false);
    checkoutButton.addEventListener("click", preventCheckoutHandler);
  } else {
    console.error("Checkout Button not found.");
  }
});
